import { useState, useRef } from "react"
import { useQuery } from "@tanstack/react-query"
import { authorizedFetch } from "@/lib/api"
import { API_URL } from "@/lib/mutation-utils"

export interface DriverOption {
  id:   string
  name: string
  code: string
}

export function useDriversSearch() {
  const [inputValue, setInputValue] = useState("")
  const [search, setSearch]         = useState("")
  const debounceRef                 = useRef<ReturnType<typeof setTimeout> | null>(null)

  function onSearchChange(value: string) {
    setInputValue(value)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => setSearch(value), 300)
  }

  const isMinLength = search.trim().length >= 3

  const { data: drivers = [], isLoading } = useQuery<DriverOption[]>({
    queryKey: ["drivers-search", search],
    enabled:  isMinLength,
    staleTime: 30_000,
    queryFn: async () => {
      const params = new URLSearchParams({
        deleted:  "false",
        pageSize: "50",
        search:   search.trim(),
      })
      const res = await authorizedFetch(`${API_URL}/api/providers/drivers?${params}`)
      if (!res.ok) return []
      const json = await res.json() as { data: DriverOption[] }
      return json.data
    },
  })

  return { drivers, isLoading, inputValue, onSearchChange, search, isMinLength }
}
